import React, { Component } from 'react';

import axios from 'axios';

import swal from 'sweetalert';

import NumberFormat from 'react-number-format';

import apiurl from './apiurl';
import ZadaniaWydzialowe from './zadaniaWydzialowe/ZadaniaWydzialowe.js';
import Popup from "reactjs-popup";





export default class RowwithButton extends React.Component {

  constructor(props) {
    super(props);    
    this.state = {
      savesuccess: false,
      saveload: true,
      wnioseczek: props.user.Wniosek,
      brakuwag: false,
      openZadWydz: false,
    };

    this.timer = this.timer.bind(this);
    this.openZadWydz = this.openZadWydz.bind(this);
    this.closeZadWydz = this.closeZadWydz.bind(this);

  }


  openZadWydz() { this.setState({ openZadWydz: true }) }

  closeZadWydz() { this.setState({ openZadWydz: false }) }


componentDidUpdate(prevProps , prevState) {
  if ( prevProps.user.Wniosek !== this.props.user.Wniosek && prevState.wnioseczek !== this.props.user.Wniosek) {
    this.setState({ wnioseczek: this.props.user.Wniosek })
  }
}





edit = (user) => {

  const nowyW =  this.state.wnioseczek.replace(',', '.');

  axios.put(apiurl+"api/Budzet?",

      {rok: this.props.rok, idUchwaly: this.props.id, idWydz: `${user.idWydzialu}`, idRodz: `${user.idRodzaju}`,

      dwbp: this.props.dwbp, dzial: `${user.Dzial}`,  rozdzial: `${user.Rozdzial}`, paragrafP4 : `${user.Paragraf}`+`${user.P4}`, pozycja: `${user.Pozycja}`, wniosek: nowyW },

      {headers : {'Content-Type': 'application/json' , 'Authorization' : "Bearer " + this.props.token} })

      .then(res => {

      this.setState({ savesuccess: true });

      setInterval(this.timer, 1000);

      this.props.zapisdata2state();

      })

      .catch((error) => {

        swal(error.response.data);

        this.setState({ saveload: true })

      });

}



timer() {

  this.setState({ savesuccess: false, saveload: true });

}



getUwaga = (idWydz, idRodz, dzial, rozdzial, paragrafp4, pozycja ) => {



  axios

    .get(apiurl+"api/UwagiParagraf", 

    {params : {

      rok: this.props.rok, 

      idUchwaly: this.props.id, 

      idWydz: idWydz, 

      DWBP: this.props.dwbp, 

      idRodz : idRodz, 

      dzial : dzial, 

      rozdzial : rozdzial, 

      paragrafp4 : paragrafp4, 

      pozycja: pozycja

    },

    headers: { 'Authorization' : 'Bearer ' + this.props.token }})

    .then(response => {

      if(response.data === null) {

        this.changeUwaga('')

      } else {

      this.changeUwaga(response.data);

      }

    })

    .catch(error => { 

      swal(error.response.data);

    })

}



changeUwaga = (value) => {

  this.setState({ uwaga : value })

}



zapiszuwaga = (u, user) => {



  u.preventDefault();

  axios.post(apiurl+"api/UwagiParagraf",

      {

        rok: this.props.rok,

        idUchwaly: this.props.id, 

        DWBP: this.props.dwbp,

        dzial : `${user.Dzial}`,

        rozdzial : `${user.Rozdzial}`,

        paragrafp4 : `${user.Paragraf}`+`${user.P4}`,

        pozycja: `${user.Pozycja}`,

        idRodz : `${user.idRodzaju}`,

        idWydz: `${user.idWydzialu}`,

        uwaga: this.state.uwaga,

      },

      {headers : {'Content-Type': 'application/json' , 'Authorization' : 'Bearer ' + this.props.token } })

      .then(res => {

        console.log(res.data);

        swal(res.data)

      })

  .catch(error => {

    swal(error.response.data)

  });

}







render() {

let { savesuccess, saveload, wnioseczek, uwaga } = this.state;

let { user, noweUwagi, idx, sorta, ukryjPlan, zadwydz, rok, idw, wersjaTabeli }  = this.props;

const { IDA, Rozdzial, Dzial, Paragraf, idRodzaju, Rodzaj, Wydzial, Opis, Przed, Po, P4, Wniosek, Pozycja, idWydzialu, poWniosku, Zmiany, uchWydzStat, uchWydzStatZad} = user;

let inputleg = Number(`${wnioseczek.length}`);

let POPID = "UwagaPop" + idx;

let POPHASH = "#" + POPID;



return (<React.Fragment>

  <td ><p class="text-right">{Dzial}</p></td>
  <td ><p class="text-right">{Rozdzial}</p></td>
  <td ><p class="text-right">{Paragraf}{P4}</p></td>
  <td ><p class="text-right">{Pozycja}</p></td>
  <td ><p>{Rodzaj}</p></td>
  <td ><p>{Wydzial}</p></td>
  <td ><p>{Opis}</p></td>
  <td ><p class="text-right kwoty"><NumberFormat value={Przed} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td>
  {!wersjaTabeli ? null : (<td ><p class="text-right kwoty"><NumberFormat value={Po} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td>)} 
  {wersjaTabeli ? null : ukryjPlan ? null : (<td ><p class="text-right kwoty"><NumberFormat value={poWniosku} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td>)}
  {ukryjPlan ? null : <td ><div className="d-flex flex-row"><p class="text-right kwoty"><NumberFormat value={Zmiany} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></div></td>}   
  <td class="text-right kwoty" ><div className="d-flex flex-row justify-content-end">
  {uchWydzStat === 'true' ? (
      <NumberFormat value={wnioseczek} size={inputleg} class="input text-right" id={IDA} onChange={(e) => (this.setState({ wnioseczek: e.target.value }))} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} />
    ) : (
      <NumberFormat value={Wniosek} class="text-right float-right" thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} />)
  }

  </div>

  </td>

  <td >

  {uchWydzStat === 'true' ?(

  <>

  <div className="d-flex flex-row">

  {savesuccess ? (<button  type="button" class="btn btn-light m-1" disabled><i class="fa fa-check"></i></button>) : (<>{saveload ? (<button type="button" onClick={() => (this.setState({ saveload: false }, this.edit(user), this.props.ChangeWniosek(wnioseczek, IDA)))} class="btn btn-light button-text m-1">Zapisz</button>) : (<button  type="button" class="btn btn-light m-1" disabled><div class="spinner-border text-primary spinner-border-sm" role="status"></div></button>)} </>)}

  {uchWydzStatZad  !== 'true'? (<button class="btn btn-danger button-text m-1" onClick={() => (this.props.ZadanieWartosci(idWydzialu, idRodzaju, Dzial, Rozdzial, Paragraf, P4, Pozycja ))} >Zadania</button>) : (<button class="btn btn-light button-text m-1" onClick={() => (this.props.ZadanieWartosci(idWydzialu, idRodzaju, Dzial, Rozdzial, Paragraf, P4, Pozycja ))} >Zadania</button>)}

  {noweUwagi ? (<button class="btn btn-light button-text m-1" data-toggle="modal" data-target={POPHASH} onClick={(e) => (this.getUwaga(idWydzialu, idRodzaju, Dzial, Rozdzial, Paragraf+P4, Pozycja ))}>Uzasadnienie</button>) : null }

  {/* {zadwydz ? (<button class="btn btn-light button-text m-1" onClick={() => (this.openZadWydz())} >Zad. Wydz.</button>) : null } */}


  </div>

  </>

  ) :(<>

  <div className="d-flex flex-row">

  {uchWydzStatZad  !== 'true'? (<button class="btn btn-danger button-text m-1" onClick={() => (this.props.ZadanieWartosci(idWydzialu, idRodzaju, Dzial, Rozdzial, Paragraf, P4, Pozycja ))} >Zadania</button>) : (<button class="btn btn-light button-text m-1" onClick={() => (this.props.ZadanieWartosci(idWydzialu, idRodzaju, Dzial, Rozdzial, Paragraf, P4, Pozycja ))} >Zadania</button>)}

  {noweUwagi ? (<button class="btn btn-light button-text m-1" data-toggle="modal" data-target={POPHASH} onClick={(e) => (this.getUwaga(idWydzialu, idRodzaju, Dzial, Rozdzial, Paragraf+P4, Pozycja ))}>Uzasadnienie</button>) : null }
  
  {/* {zadwydz ? (<button class="btn btn-light noWrap m-1"  onClick={() => (this.openZadWydz())} >Zad. Wydz.</button>) : null } */}

  </div>

  </>)

  }

  </td> 





  <div class="modal fade" id={POPID} tabindex="-1" role="dialog" aria-labelledby="UwagiRowTitle" aria-hidden="true">

  <div class="modal-dialog modal-dialog-centered" role="document">

  <div class="modal-content">

    <div class="modal-header">

    <h5 class="modal-title" id="UwagiRowTitle">Uzasadnienie</h5>

    <button type="button" class="close" data-dismiss="modal" aria-label="Close">

    <span aria-hidden="true">&times;</span>

    </button>

    </div>

    <div class="modal-body">

    <div class="d-flex flex-row">

    <textarea type="text" class="form-control" value={uwaga} rows="3" id="uwaga" placeholder="Wprowadź uzasadnienie do wniosku..."  onChange={(e) => (this.changeUwaga(e.target.value))}></textarea>

    </div>

    </div>

    <div class="modal-footer">

    <button type="button" class="btn btn-secondary" data-dismiss="modal">Zamknij</button>



    <button  onClick={(u) => ( this.zapiszuwaga(u, user))} type="button" class="btn btn-primary">Zapisz</button>

    </div>

    </div>

  </div>

  </div>


  <Popup open={this.state.openZadWydz} closeOnDocumentClick onClose={this.closeZadWydz}>
    <div class="okno">
      <div className='d-flex flex-row flex-container'>
        <h4 className='m-2'>Zadania wydziałowe</h4>
        <button type="button" class="close ml-auto mr-1" aria-label="Close" onClick={() => (this.closeZadWydz())}>
          <span aria-hidden="true">&times;</span>
        </button>  
      </div>  
      <div className='d-flex flex-container mt-2'>
        <ZadaniaWydzialowe token={this.props.token} rok={rok} user={user} idw={idw} />
      </div>
    </div>
  </Popup>

</ React.Fragment>)}

}





